import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreComponentsModule } from '@lx/core/components';
import { DatePipe, PricePipe } from '@lx/shared/ui/pipes';
import { CourseTypeSelectorComponent } from './course-type-selector/course-type-selector.component';
import { ProgramTypeSelectorComponent } from './program-type-selector/program-type-selector.component';
import { DetailsPopupComponent } from '../details-popup/details-popup.component';
import { FormFieldSelectorComponent } from '../form-field-selector/form-field-selector.component';
import { ItemCardComponent } from '../item-card/item-card.component';
import { OfferLabelComponent } from '../offer-label/offer-label.component';

@NgModule({
  declarations: [CourseTypeSelectorComponent, ProgramTypeSelectorComponent],
  imports: [CommonModule, CoreComponentsModule, PricePipe, DatePipe, OfferLabelComponent, DetailsPopupComponent, FormFieldSelectorComponent, ItemCardComponent],
  providers: [DatePipe],
  exports: [CourseTypeSelectorComponent, ProgramTypeSelectorComponent],
})
export class CourseComponentsModule {}
